import { render } from "./MandatoryChecks.vue?vue&type=template&id=86b75e7e&scoped=true"
import script from "./MandatoryChecks.vue?vue&type=script&lang=js"
export * from "./MandatoryChecks.vue?vue&type=script&lang=js"

import "./MandatoryChecks.vue?vue&type=style&index=0&id=86b75e7e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b75e7e"]])

export default __exports__